<template>
    <div>
        <v-menu v-model="menu"
                :close-on-content-click="false"
                full-width>
            <template v-slot:activator="{ on }">
                <v-text-field
                        label="项目类型"
                        readonly
                        v-model="text"
                        append-icon="search"
                        clearable
                        @click:append="menu = !menu"
                        v-on="on">
                </v-text-field>
            </template>

            <v-card>
                <v-treeview
                        v-model="selected"
                        :items="items"
                        item-key="dbid"
                        activatable
                        active-class="grey lighten-4 indigo--text"
                        selected-color="indigo"
                        open-on-click
                        selectable
                        return-object
                />
            </v-card>
        </v-menu>
    </div>
</template>
<script>
    const typeTreeUri = '/api/proj/project-type/get/tree';

    export default {
        name: 'ProjTpeTree',
        model: {
            prop: 'values', // 选中的树节点的 dbid
            event: 'input'
        },
        props: ["values"],

        data: () => ({
            menu: false,

            items: [], // 树节点
            selected: [],  // 选中的树节点
        }),

        created() {
            const vm = this;
            this.axios.get(typeTreeUri).then(rsp => {
                vm.items = rsp.data.items;

                if (Array.isArray(vm.values)) {
                    // window.console.log(vm.values);
                    vm.selected = vm.getNodes(vm.values);
                    //window.console.log(vm.selected)
                }
            })

        },
        watch: {
            selected(nv) {
                const val = (nv || []).filter(v => v.leaf).map(v => v.dbid);
                this.$emit('input', val);
            }
        },
        computed: {
            text: {
                get() {
                    const vals = [];

                    const parentIsSelected = (p) => {
                        for (const n of this.selected) {
                            if (n.dbid === p.parentId) return true;
                        }
                        return false;
                    };

                    for (const n of this.selected) {
                        if (!parentIsSelected(n)) vals.push(n);
                    }

                    return vals.map(v => v.name).join('; ');
                },
                set(val) {
                    if (!val || val.length === 0)
                        this.selected = [];
                }
            },
        },
        methods: {
            getNodes(ids) {
                const get_nodes_by_id = (nodes, ids) => {
                    if (Array.isArray(nodes)) {
                        let selects = nodes.filter(v => ids.find(e => e === v.dbid));
                        nodes.forEach(n => {
                            selects = selects.concat(get_nodes_by_id(n.children, ids))
                        });
                        return selects;
                    } else {
                        return [];
                    }
                };

                return get_nodes_by_id(this.items, ids);
            }
        }
    }
</script>

<style>

</style>
